import { atom } from "jotai";

export type VideoDisplayState = "unavailable" | "processing" | "ended" | "black" | "video";

export const webcamDisplayStateAtom = atom<VideoDisplayState>("black");
export const screencaptureDisplayStateAtom = atom<VideoDisplayState>("black");
export const videoDisplayStateAtom = atom<VideoDisplayState>((get) => {
	const webcamDisplayState = get(webcamDisplayStateAtom);
	const screencaptureDisplayState = get(screencaptureDisplayStateAtom);
	if (webcamDisplayState === "unavailable" && screencaptureDisplayState === "unavailable") {
		return "unavailable";
	} else if (webcamDisplayState === "ended" && screencaptureDisplayState === "ended") {
		return "ended";
	}
	return "video";
});

// TODO: refactor out to depend on startDate
export const webcamEndDateAtom = atom<Date | undefined>(undefined);
export const screencaptureEndDateAtom = atom<Date | undefined>(undefined);
export const videoEndDateAtom = atom<Date | undefined>((get) => {
	const webcamEndDate = get(webcamEndDateAtom);
	const screencaptureEndDate = get(screencaptureEndDateAtom);
	if (!webcamEndDate || !screencaptureEndDate) {
		return undefined;
	}
	if (webcamEndDate > screencaptureEndDate) {
		return webcamEndDate;
	}
	return screencaptureEndDate;
});

export const roomscanDisplayStateAtom = atom<VideoDisplayState>("black");
